
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venta-pisos/[...categories]",
      function () {
        return require("private-next-pages/venta-pisos/[...categories].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venta-pisos/[...categories]"])
      });
    }
  